(function () {
  'use strict';
  var TOAST = '.restock-alerts-toast';
  var FORM = '.restock-alerts-form';

  function visible(el) {
    return !!el && el.getClientRects().length > 0;
  }

  function targetForm() {
    var forms = document.querySelectorAll(FORM);
    for (var i = 0; i < forms.length; i++) if (visible(forms[i])) return forms[i];
    return forms[0] || null;
  }

  function adopt(toast) {
    var form = targetForm();
    if (!form) return; // no form on this page: leave the app's toast alone
    var text = (toast.textContent || '').trim();
    if (!text) return;
    var notice = form.querySelector('.sp-nm-notice');
    if (!notice) {
      notice = document.createElement('p');
      notice.className = 'sp-nm-notice';
      notice.setAttribute('role', 'status');
      notice.setAttribute('aria-live', 'polite');
      var btn = form.querySelector('.restock-alerts-submit-button');
      if (btn && btn.parentNode) btn.parentNode.insertBefore(notice, btn.nextSibling);
      else form.appendChild(notice);
    }
    notice.textContent = text;
    toast.style.display = 'none';
  }

  var mo = new MutationObserver(function (records) {
    for (var r = 0; r < records.length; r++) {
      var added = records[r].addedNodes;
      for (var i = 0; i < added.length; i++) {
        var n = added[i];
        if (n.nodeType !== 1) continue;
        var t = n.matches && n.matches(TOAST) ? n : (n.querySelector ? n.querySelector(TOAST) : null);
        if (t) adopt(t);
      }
    }
  });
  mo.observe(document.body, { childList: true, subtree: true });
})();
